'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.form.input-slider', []);

_module.directive('inputSlider', inputSliderDirective);

exports.default = _module;


function inputSliderDirective() {
    return {
        restrict: 'A',
        controller: ['$element', function controller($element) {
            var steps = $element.find('.input-slider__step');
            var slider = $element.find('.input-slider__input');
            slider.on('change', function () {
                var value = slider[0].value;

                for (var i = 0; i < steps.length; i++) {
                    steps[i].style.width = 'calc(100% / ' + steps.length + ')';
                    steps[i].classList.remove('input-slider__step--active');
                    if (steps[i].attributes.step.value == value) {
                        steps[i].classList.add('input-slider__step--active');
                        slider[0].setAttribute('aria-describedby', steps[i].id);
                    }
                }
            });
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/form/slider/input-slider.directive.js
// module id = 889
// module chunks = 0